module.exports = __webpack_public_path__ + "img/security-dsc.673cba54.png";